'use client';

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/components/ui/PageHeader';
import { getLocalizedPath } from '@/components/helpers/localize';
import { Locale } from '@/lib/enums/locale.enum';

export const SearchPageHeader: React.FC = () => {
  const { t, i18n } = useTranslation();
  return (
    <PageHeader
      title={t('components.breadcrumbs.search')}
      breadcrumb={[
        {
          label: t('components.breadcrumbs.frontpage'),
          href: getLocalizedPath('frontpage', 'frontpage', i18n.language as Locale),
        },
        {
          label: t('components.breadcrumbs.search'),
        },
      ]}
    />
  );
};
